import { render, staticRenderFns } from "./ContentPageItem.vue?vue&type=template&id=0cf7d236&scoped=true&"
import script from "./ContentPageItem.vue?vue&type=script&lang=js&"
export * from "./ContentPageItem.vue?vue&type=script&lang=js&"
import style0 from "./ContentPageItem.vue?vue&type=style&index=0&id=0cf7d236&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7d236",
  null
  
)

export default component.exports